import { useQuery, useMutation, } from "@tanstack/react-query";
export const createContestsEditionsStylesQueries = (requests, queryClient) => ({
    useListContestsEditionsStyles: (params, options = {}) => useQuery({
        queryKey: ["contests-editions-styles", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listContestsEditionStyles(params);
        },
        ...options,
    }),
    useCreateContestsEditionsStyle: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionsStyleAttrs) => {
            return requests.createContestsEditionStyle(contestsEditionsStyleAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({
                queryKey: [
                    "contests-editions-styles",
                    "contests-edition-style-categories",
                    "styles",
                ],
            });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useUpdateContestsEditionsStyle: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionsStyleAttrs) => {
            return requests.updateContestsEditionStyle(contestsEditionsStyleAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-styles"],
            });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useDeleteContestsEditionsStyle: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionsStyleId) => {
            return requests.deleteContestsEditionStyle(contestsEditionsStyleId);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({
                queryKey: [
                    "contests-editions-styles",
                    "contests-edition-style-categories",
                    "styles",
                ],
            });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useListStyleCategories: (params, options = {}) => useQuery({
        queryKey: ["style-categories", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listContestsEditionStyleCategories(params);
        },
        ...options,
    }),
    useFindStyleCategory: (params, options = {}) => useQuery({
        queryKey: ["style-category", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findContestsEditionStyleCategory(params);
        },
        ...options,
    }),
    useCreateStyleCategory: (options = {}) => useMutation({
        ...options,
        mutationFn: (styleCategoryAttrs) => {
            return requests.createContestsEditionStyleCategory(styleCategoryAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["style-categories"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useUpdateStyleCategory: (options = {}) => useMutation({
        ...options,
        mutationFn: (styleCategoryAttrs) => {
            return requests.updateContestsEditionStyleCategory(styleCategoryAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["style-categories"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useDeleteStyleCategory: (options = {}) => useMutation({
        ...options,
        mutationFn: (styleCategoryId) => {
            return requests.deleteContestsEditionStyleCategory(styleCategoryId);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["style-categories"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
});
//# sourceMappingURL=index.js.map